import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";

export function RLConditionalFieldsConfig() {
    let directive: ng.IDirective = {
        template: require("/assets/app/templates/conditional-fields-config.html"),
        controller: RLConditionalFieldsConfigController,
        bindToController: true,
        controllerAs: "cfVM",
        scope: {
            charTypeID: "=charTypeId",
            templateID: "=templateId",
            charID: "=charId",
            label: "=",
            conditionalField: "=",
            triggerFields: "="
        }
    };
    return directive;
}

export class RLConditionalFieldsConfigController {

    public static $inject = ["$scope", "$window", "entityConfigService", "entityService"];

    private charTypeID: number;
    private templateID: number;
    private charID: number;
    public label: string;

    public conditionalField: Models.IConditionalField;
    public triggerFields: Models.ICharacteristicMetaData[] = [];

    private selectedField: Models.ICharacteristicMetaData;
    public triggerFieldLOVs: Models.ICharacteristicMetaDataValue[] = [];
    public hasLOVValueList: Models.ICharacteristicMetaDataValue[] = [];
    // used in the commented code below
    //private triggerValue: string;
    //private triggerValueFieldType: string;
    public hasLOVValueIDs: number[];
    private fieldTypes: Models.IKeyValuePair<string, string>[] = [];
    public showDeletedParentMessage: boolean;

    public constructor(private readonly $scope: ng.IScope,
        private readonly $window: ng.IWindowService,
        private readonly entityConfigService: EntityConfigService,
        private readonly entityService: EntityService) {

        $scope.$watchGroup([() => this.charTypeID, () => this.templateID, () => this.charID],
            (newValue, oldValue) => {
                if (newValue[0] != null && newValue[1] != null && newValue[2] != null) {
                    this.Init();
                }
            });

        this.$scope.$watchCollection(() => [this.conditionalField.triggerCharID, this.triggerFields], (newValue, oldValue) => {
            let newTriggerCharId = newValue[0];
            let oldTriggerCharId = oldValue[0];
            let newTriggerFields = newValue[1];

            if (newTriggerCharId > 0 && newTriggerFields) {
                if (this.triggerFields.length > 0) {
                    //Set the default value for the type
                    this.conditionalField.conditionalFieldTypeID = "932B1D41-9578-E811-8129-DBC5C04FF85E";

                    this.selectedField = _.first(_.filter(this.triggerFields, f => f.characteristicID == this.conditionalField.triggerCharID));

                    //Make sure the triggerCharID is still valid.  The parent characteristic can get deleted
                    if (_.isNull(this.selectedField)) {
                        //The parent trigger field has been deleted or something happened to it.
                        //Delete the conditional field for data cleanup, and show a message
                        this.entityConfigService.deleteConditionalField(this.conditionalField);
                        this.showDeletedParentMessage = true;
                    } else {
                        this.showDeletedParentMessage = false;
                        this.GetLOVs();

                        // clear out the old trigger value if a new trigger char id was selected
                        if (newTriggerCharId != oldTriggerCharId && oldTriggerCharId > 0) {
                            this.conditionalField.triggerValue = "";
                        }

                        //If the trigger field is an LOV, then populate the hasLOVValueIDs
                        if (this.selectedField.charValueSourceID && this.selectedField.charValueSetID) {
                            //Split the value
                            if (this.conditionalField && !_.isEmpty(this.conditionalField.triggerValue)) {
                                this.hasLOVValueIDs = this.conditionalField.triggerValue.split("|").map(v => _.parseInt(v));
                            }
                        }
                    }
                }
            }
        });

        this.$scope.$watch(() => this.hasLOVValueIDs, (newValue, oldValue) => {
            if (newValue != oldValue && newValue) {
                this.SetTriggerValue(newValue, "tree");
            }
        }, true);
    }

    public Init() {
        //Get the field type options
        this.entityConfigService.getConditionalFieldTypes()
            .then((results) => {
                this.fieldTypes = results;
            });
    }

    private GetLOVs() {
        this.triggerFieldLOVs = [];
        this.hasLOVValueIDs = [];

        let charValueSourceID = this.selectedField.charValueSourceID;
        let charValueSetID = this.selectedField.charValueSetID;

        if (!_.isNull(charValueSourceID)) {
            //Populate the applicable LOV
            this.entityService.getCharLovMetaData(charValueSourceID, charValueSetID)
                .then((result) => {
                    this.triggerFieldLOVs = result.listOfValues;

                    //Add the Any Value option
                    let anyValueOption: Models.ICharacteristicMetaDataValue = {
                        characteristicValueID: -999,
                        characteristicValueLabel: "- Any Value -",
                        childValues: [],
                        defaultIndicator: 0,
                        sequenceNumber: 0
                    };

                    this.triggerFieldLOVs.unshift(anyValueOption);
                });
        }
    }

    //Not needed since we're only showing LOV (treelist).  May need in the near future.  Feel free to delete
    //if this isn't being used by 1-1-2019
    // ShowField() {
    //     if (this.selectedField != null) {
    //         //Determine which type of input to show based on the trigger field
    //         if (this.selectedField.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.money ||
    //             (this.selectedField.multipleIndicator == 0 && !this.selectedField.charValueSourceID)) {
    //             this.triggerValueFieldType = "text";
    //         } else if (this.selectedField.multipleIndicator == 0 && this.selectedField.charValueSourceID) {
    //             this.triggerValueFieldType = "tree";
    //         } else if (this.selectedField.multipleIndicator == 1 && this.selectedField.charValueSourceID) {
    //             this.triggerValueFieldType = "tree";
    //         }

    //         return true;
    //     }

    //     return false;
    // }

    private SetTriggerValue(value: any, type: string) {
        let result: string;

        switch (type) {
            case "text":
                result = _.trim(value);
                break;
            case "select":
                result = String(value);
                break;
            case "tree":
                let ids: string[] = value.map(v => v.toString());
                let anySelection = ids.find(v => v === "-999");
                result = anySelection ? anySelection : ids.join("|");
                break;
        }

        this.conditionalField.triggerValue = result;
    }

    public DeleteConditionalField() {
        if (this.$window.confirm("Are you sure?")) {
            this.selectedField = null;
            this.$scope.$emit(Consts.Events.DeleteConditionalField);
        }
    }

    public ClearConditionalField() {
        this.selectedField = null;
        this.conditionalField = {
            charID: this.charID,
            charTypeID: this.charTypeID,
            conditionalFieldID: null,
            conditionalFieldTypeID: null,
            divID: 0,
            templateID: this.templateID,
            triggerCharID: 0,
            triggerGroupID: null,
            triggerValue: ""
        };
    }
}
